import {colors} from 'config/styles';
import {ActivityIndicator} from 'react-native';

export function Loading() {
  return (
    <ActivityIndicator 
      color={colors.primary.brand}
      size="large"
    />
  );
}
